import React from 'react';
import LinkPreviewViewer from './LinkPreviewViewer.js';
import 'lodash';
import 'wix-rich-content-common';
import 'wix-rich-content-common/dist/statics/schemas/plugin-link-preview.schema.json';
import './link-preview-3953da8d.js';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';
import './types.js';

const LinkPreviewComponent = ({
  blockProps,
  settings,
  theme,
  isMobile,
  iframeSandboxDomain
}) => {
  return /* @__PURE__ */ React.createElement(
    LinkPreviewViewer,
    {
      componentData: blockProps.getData(),
      settings,
      theme,
      isMobile,
      iframeSandboxDomain
    }
  );
};

export { LinkPreviewComponent as default };
//# sourceMappingURL=LinkPreviewComponent.js.map
